var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKnotWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 339 522",
    style: {
      enableBackground: "new 0 0 339 522"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st030{fill:none;stroke:#FFFFFF;stroke-width:2.6;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000081643291671653458130000000454181925062245278_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st030",
    d: "M50.8,83.4C73.1,37.4,123.3,19,177.4,19c53,0,108.1,19.4,126.3,56.7c8.7,5.6,15.2,12.8,12.7,23.3 c1.1,3.5,0.8,7.3-0.8,10.6c1,2.8,1.4,13.8-10.1,20.8c-20.8,52.8-69.7,91.7-105.5,126c28.9,24.7,81.3,75.4,96.1,110 c13.9,3,23.5,15.6,18.7,22.9c1.6,5.3,1.8,8.9,0.1,11.5c0.5,2.7,1.2,7.1-1.2,10.1c2.2,5.5,0.2,13.3-10,18.4 c-15.5,51.8-84.2,69.9-130.1,69.9C93,499,30.9,466.9,28.2,415.3c-8.1-9.4-8.4-18.6-6.5-25.1c1.5-5.1,3.3-10.1,5.5-14.9 c1.4-2.9,6.5-11.5,16.2-13.6c26.1-41.2,72.5-83.2,99.7-108.5c-36.8-35-82.4-79.5-93.1-117.7c-6.9-5.2-10.9-11.3-11.1-14.9 c-0.5-7.5-1.1-18.5-1-20.7C38.2,96.6,40.8,87.8,50.8,83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st030",
    d: "M88.1,88.2c9.2-34.8,60.1-53.7,98.5-54.5c34.5-0.7,70.3,18.1,80.1,44.8c-4.9,3.9-12,13.1-10.7,23.1 c-0.6,3.2-0.7,6.4-0.5,9.6c-1.5,3.4-1.3,14,2.4,18.2c-13.8,30.6-67.7,80.4-87.9,99.3c-49.3-45.7-69.8-72.9-80.7-100.4 c3.1-3.5,4.9-7.9,5.4-12.5c0.4-4-0.2-16.1-0.2-18S90.8,90.1,88.1,88.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st030",
    d: "M173.6,280.7c16.6,12.9,72.4,67.4,86.7,102.2c-1.6,3.2-0.5,7.7-0.5,9.1c-1.1,3-1.3,6.3-0.5,9.5 c-0.9,2.2-3.8,15.1,6.9,22.5c-9.6,44.2-62.6,61-109.8,61S68,453,69.6,421.7c7.7-5.6,9.7-10,11.7-14.9c4.7-11.5,6.7-18.3,1.7-26.5 C97.3,355.4,130.2,320.1,173.6,280.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st030",
    d: "M38,102.4c0,4.6,5.8,20.2,27.1,20.2c23.5,0,29.5-18.7,29.5-24.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st030",
    d: "M38.6,110.2c0,11.8,13.1,20.4,26,20.4c12.6,0,30-8,30-25.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st030",
    d: "M50,135.3c13,7.7,33.9,0.9,39.3-7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st030",
    d: "M50.8,83.4c-2,6.3-3.5,12.8-4.5,19.4c3.9,3.8,8.6,9.2,18.9,8.7c10.6-0.6,18.9-8,20.6-14 c1.2-4.6,1.5-7.3,2.2-9.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st030",
    d: "M56.9,110.2C57.2,97.5,60,86,68.2,75C83,55.1,117.5,31.2,172.7,31.2c14.1,0,38,1.3,60.5,13.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st030",
    d: "M208.4,35.1c-21.9-4.4-33.1-3.4-59.5,1.1c-38.7,6.5-81.7,34.5-77.3,74.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st030",
    d: "M60.8,111.5c-1.1-8.6-1-34.2,25.3-54.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st030",
    d: "M74.5,109c-1.4-9.6,1.6-33.8,15.8-44.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st030",
    d: "M266.8,78.5c5.6-4.8,22.9-9.2,37-2.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st030",
    d: "M169,19c36.6,0,89.2,9.3,109.2,54.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st030",
    d: "M186.9,19.2c42.4,1.4,88.6,21.7,103.1,53.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st030",
    d: "M256.1,101.6c1.6-6.7,10.1-18.8,30.6-19.5c12-0.4,24.3,4.5,29.7,16.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st030",
    d: "M255.6,111.2c1.7-4.6,8.7-18.4,31.1-19c16.5-0.4,26.8,9.6,28.9,17.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st030",
    d: "M258,129.4c1.8-4,7.3-15.8,8-18.2s10-7,20.3-7c11.7,0,26.8,7.6,19.3,26.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st030",
    d: "M280.1,104.7C266.3,196.8,64.4,305.9,41.8,397.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st030",
    d: "M45.4,399.7c20.2-93.4,229-208.8,237.8-295.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st030",
    d: "M295.2,105.6c-15,100.7-220.6,207.5-238.4,297.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st030",
    d: "M60.4,402.9C86.7,304.6,292.2,195,298.2,106.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st030",
    d: "M43.5,361.6c-3.2,5.9-18.9,30.8,6.5,40.4c15.2,5.8,26.1-8.1,33-21.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st030",
    d: "M143.1,253.1c3.1-3.1,24.9-22.5,26.9-24.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st030",
    d: "M62.7,138.7c15,40.1,75.7,95.2,88.7,106.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st030",
    d: "M66.5,138.7c15.3,40.2,73,93.7,86,105.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st030",
    d: "M77.6,136.2c14.9,39.3,74.2,93.3,82.9,101.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st030",
    d: "M80.3,135.1c11.7,30.8,49.7,72.7,81.4,101.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st030",
    d: "M260.4,382.9c1.5-3.9,10.9-20.1,35.7-16.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st030",
    d: "M173.6,280.7c2.6-2.4,24.2-22.3,26.4-24.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st030",
    d: "M181.7,273.3c28.5,25.6,76.4,74.8,85.8,100.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st030",
    d: "M182.8,272.3c7.3,6.8,73.7,66.2,87.6,99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st030",
    d: "M280.5,366.9c-14.2-31-69.7-85-90-101.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st030",
    d: "M283.4,366.3c-9.1-22.9-47.9-63.6-91.6-102.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st030",
    d: "M259.9,392c3.1-7.2,10.2-17,27.6-17.1c12.9-0.1,21.1,4.7,27.3,14.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st030",
    d: "M259.4,401.5c2.8-6.8,10.5-17.3,28-17.3c14.1,0,24.2,7.6,27.5,16.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st030",
    d: "M28.2,415.2c10.5,9.9,23.9,14.3,41.4,6.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st030",
    d: "M172.7,499c-24.5,0.6-109.1-9.5-114.8-73.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st030",
    d: "M76.5,465.6c-9.5-9.9-18.5-24.1-20.8-40.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st030",
    d: "M169.8,499c-22.9,0-116.2-8.8-126.2-74.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st030",
    d: "M60.8,460.2c-6.4-6.6-17.8-22.8-19.5-36.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st030",
    d: "M302.1,433.9c1.2-3.6,4.9-13.6,4.9-24.7c0-4.6-0.4-6.9-3.6-9.3c-4.9-3.4-10.7-5.2-16.7-5.2 c-6.3,0-19.5,4.1-16.8,15.3c-0.1,3-2.9,11.4-3.9,15.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st030",
    d: "M111.7,475.1c36.5,18.9,136.5,22,176.5-37.4c6.9-10.3,9.9-25.2,6.4-41.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st030",
    d: "M291.3,395.1c1.6,8.2,5.8,40.2-20,61.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st030",
    d: "M129.1,481.6c37.3,8.1,90.8,6.8,129.2-23.8c16.4-13.1,27.7-32.7,21.8-61.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st030",
    d: "M276.6,397.3c2,9.3,6.6,39.7-18.3,60.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st030",
    d: "M23.6,384.4c-4.9,14.7,8.7,34.8,28.4,36.1c14,0.9,26.6-6.9,31-18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st030",
    d: "M85.2,395.3c-2.1,6.8-15.3,25.2-39.1,18.1c-17.3-5.1-25.4-23.8-19.5-36.9"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnotWhite);
export default __webpack_public_path__ + "static/media/knot-white.e823af39f2f2e3b0d244e3533159652c.svg";
export { ForwardRef as ReactComponent };